export const DISABLED = 'inclusion or disabled';
export const ORPHAN = 'orphan';
export const FATHER_DIED_ATO = 'fathers who died in the ATO (disappeared without a trace)';
export const LARGE_FAMILY = 'large family';
export const LARGE_FAMILY_INCLUSION = 'large family, where there is inclusion';
export const CANCER = 'cancer';
export const MIGRANTS = 'migrants';
export const ATO_FAMILY = 'ATO families';
export const DIFFICULT_CIRCUMSTANCES = 'difficult circumstances';
